import { useAuthStore } from "../stores/authStore";

const REFRESH_WINDOW_MS = 60_000;
const CHECK_INTERVAL_MS = 60_000;

// Devuelve un token válido, renovándolo silenciosamente si está por expirar.
// Retorna null si no hay sesión o el refresh falló (el llamador decide logout).
export async function ensureFreshToken(): Promise<string | null> {
  const state = useAuthStore.getState();
  const token = state.token;
  if (!token) return null;

  const user = state.user;
  const expiresAt = user?.expiresAt ?? 0;

  if (expiresAt && Date.now() >= expiresAt - REFRESH_WINDOW_MS) {
    if (!user?.refreshToken) return token;
    const ok = await state.refreshAccessToken();
    if (!ok) return null;
    return useAuthStore.getState().token;
  }

  return token;
}

function maybeRefreshInBackground(): void {
  const state = useAuthStore.getState();
  const user = state.user;
  if (!user?.token || !user.refreshToken) return;
  if (user.expiresAt && Date.now() >= user.expiresAt - REFRESH_WINDOW_MS) {
    void state.refreshAccessToken();
  }
}

let started = false;

// Renovación de fondo: mantiene sesiones vivas en pestañas/PWA silenciosamente.
export function startSessionMaintenance(): void {
  if (started) return;
  started = true;

  const tick = () => maybeRefreshInBackground();
  setInterval(tick, CHECK_INTERVAL_MS);
  window.addEventListener("focus", tick);
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "visible") tick();
  });
}